import { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'

export const FullScreenModal = ({
    showModal,
    setShowModal,
    modalContent,
    mediaItem,
    setModalContent,
    handleCloseModal,
    maxIndex,
}) => {
    const [isPlaying, setIsPlaying] = useState(null)
    const handlePrev = () => {
        setModalContent((prevState) => ({
            ...prevState,
            index: prevState.index > 0 ? prevState.index - 1 : prevState.index,
        }))
    }

    const handleNext = (modalContent) => {
        setModalContent((prevState) => ({
            ...prevState,
            index: prevState.index === modalContent.index - 1 ? modalContent.index : prevState.index + 1,
        }))
    }
    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'auto'
        }
    }, [showModal])
    return (
        showModal && (
            <div className={`z-50 fixed top-0 left-0  w-full h-full  bg-black/80 ${showModal ? 'block' : 'hidden'}`}>
                <div
                    onClick={(e) => e.stopPropagation()}
                    className='md:w-[80%] w-[90%] max-h-[90vh] mx-auto absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 m-auto z-30 overflow-y-auto'
                >
                    <div>
                        {/* {modalContent.contentType === 'image' && (
                            <button onClick={handleCloseModal} className='flex ml-auto'>
                                <img src={`${process.env.PUBLIC_URL}/images/close.png`} alt='close' />
                            </button>
                        )} */}
                        <button onClick={handleCloseModal} className=' right-0 flex ml-auto'>
                            <img src={`${process.env.PUBLIC_URL}/images/close.png`} alt='close' />
                        </button>
                        <div className='flex flex-col md:flex-row items-center justify-center'>
                            {modalContent.contentType === 'image' && (
                                <>
                                    {' '}
                                    <div className='flex justify-center items-center md:relative'>
                                        <div className='hidden md:flex flex-col justify-center items-center'>
                                            <button onClick={handlePrev} disabled={modalContent.index <= 1}>
                                                <img
                                                    className={`w-full min-w-[30px] max-w-[30px] ${
                                                        modalContent.index <= 1 ? 'brightness-50' : ''
                                                    }`}
                                                    src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                                    alt='left'
                                                />
                                            </button>
                                        </div>
                                    </div>
                                    <div className='h-full w-full m-4'>
                                        {' '}
                                        <img
                                            className='white-drop-shadow mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/ss/ss-${modalContent.category}-${modalContent.index}.webp`}
                                            alt='screen shot of game system'
                                        />
                                    </div>{' '}
                                    <div className='flex justify-center items-center md:relative'>
                                        <div className='hidden md:flex flex-col justify-center items-center'>
                                            <button onClick={handleNext} disabled={modalContent.index >= maxIndex}>
                                                <img
                                                    className={`w-full min-w-[30px] max-w-[30px] ${
                                                        modalContent.index >= maxIndex ? 'brightness-50' : ''
                                                    }`}
                                                    src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                                    alt='right'
                                                />
                                            </button>
                                        </div>
                                    </div>
                                    <div className='flex md:hidden justify-between w-full mt-4'>
                                        <button onClick={handlePrev} disabled={modalContent.index <= 1}>
                                            <img
                                                className={`w-full min-w-[30px] max-w-[30px] ${
                                                    modalContent.index <= 1 ? 'brightness-50' : ''
                                                }`}
                                                src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                                alt='left'
                                            />
                                        </button>
                                        <button onClick={handleNext} disabled={modalContent.index >= maxIndex}>
                                            <img
                                                className={`w-full min-w-[30px] max-w-[30px] ${
                                                    modalContent.index >= maxIndex ? 'brightness-50' : ''
                                                }`}
                                                src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                                alt='right'
                                            />
                                        </button>
                                    </div>
                                </>
                            )}

                            {modalContent.contentType === 'video' && (
                                <div className='w-full relative'>
                                    <button
                                        onClick={handleCloseModal}
                                        className='absolute tracking-wider text-white top-0 right-0'
                                        // style={{ padding: '20px' }}
                                    >
                                        <img src={`${process.env.PUBLIC_URL}/images/close.png`} alt='close' />
                                    </button>

                                    <div className='w-full max-h-[80%]'>
                                        <div className='player-wrapper' />

                                        <ReactPlayer
                                            url={modalContent.url}
                                            controls={true}
                                            onPlay={() => {
                                                setIsPlaying(1)
                                            }}
                                            width='100%'
                                            height='100%'
                                            playing={isPlaying === 1}
                                            config={{
                                                youtube: {
                                                    playerVars: { showinfo: 1 },
                                                },
                                            }}
                                            className='react-player bg-black'
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    )
}
